var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from "lodash";
import { INDOOR_MAP } from "../store/common/constants";
import translations from "../translations/resources/en-GB.json";
import { setSearchClicked } from "../store/reducers/venuesSlice";
import indoorHelper from "../store/helpers/indoorHelper";
import { DRAFT_TYPE } from "../store/common/constants";
export var searchVenueFromList = function (listViewSearchInput, listViewSortInput, filterValue, setVenueState) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var venuesListData, showAll, search, filteredSearchedMap, response;
        return __generator(this, function (_a) {
            venuesListData = getState().venues.list;
            showAll = translations.data["venonboard.listView.filter.showAll"];
            search = listViewSearchInput === null || listViewSearchInput === void 0 ? void 0 : listViewSearchInput.trim().toLowerCase();
            dispatch(setSearchClicked(null));
            filteredSearchedMap = venuesListData.filter(function (obj) {
                if (listViewSearchInput === "") {
                    return true;
                }
                return _.some(INDOOR_MAP.SEARCH_FIELD, function (searchField) {
                    var searchElement = indoorHelper.getPropertyValueByString(searchField, obj);
                    var searchedTrimElement = searchElement && searchElement.toString().trim();
                    return (searchedTrimElement &&
                        searchedTrimElement.toLowerCase().includes(search));
                });
            });
            // 2. Status Filtering (if applicable)
            if (filterValue && filterValue !== showAll) {
                filteredSearchedMap = filteredSearchedMap.filter(function (venue) { return venue.draftStatus === filterValue; });
            }
            response = filteredSearchedMap;
            if (listViewSortInput !== "") {
                if (listViewSortInput === "modified") {
                    response = _.orderBy(response, function (dateObj) {
                        return new Date(dateObj.modified);
                    }, ["desc"]);
                }
                else {
                    response = _.orderBy(response, listViewSortInput, ["asc"]);
                }
            }
            setVenueState(response);
            return [2 /*return*/];
        });
    }); };
};
export var processDraftPayload = function (args) {
    var venue = args.venue, userInfo = args.userInfo, draftType = args.draftType;
    var address = venue.address, location = venue.location, isPrivate = venue.isPrivate, id = venue.id, venueCategory = venue.venueCategory, mapDetails = venue.mapDetails;
    var getRequesterInfo = function () {
        var email = userInfo.email, firstName = userInfo.firstName, lastName = userInfo.lastName, realm = userInfo.realm;
        var requesterInformation = {
            email: email,
            firstName: firstName,
            lastName: lastName,
            organizationId: realm,
        };
        return { requesterInformation: requesterInformation };
    };
    var setDraftRequest = function (orderData) {
        var requestPayload = __assign({}, defaultProperties(orderData));
        if (draftType === DRAFT_TYPE.UPDATE_ORDER) {
            Object.assign(requestPayload, getUpdateRequestPayload(orderData));
        }
        return requestPayload;
    };
    var getUpdateRequestPayload = function (orderDataList) {
        return __assign(__assign({}, defaultProperties(orderDataList)), { isDraft: true, indoorMapId: id, draftType: DRAFT_TYPE.UPDATE_ORDER });
    };
    var getDefaultRequestProperties = function () {
        return defaultProperties();
    };
    var defaultProperties = function (orderDataList) {
        return {
            orderData: __assign(__assign(__assign({}, getRequesterInfo()), { mapName: venue.name, notes: venue.description, isPrivate: isPrivate }), orderDataList),
            venueCategory: venueCategory,
            address: address,
            location: location,
            mapDetails: mapDetails,
            draftType: DRAFT_TYPE.NEW_ORDER,
        };
    };
    return { getRequesterInfo: getRequesterInfo, setDraftRequest: setDraftRequest, getDefaultRequestProperties: getDefaultRequestProperties };
};
